<template>
  <div class="block">
    <!-- 地址列表显示框 -->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item style="width:300px">
          <el-input
            v-model="page.criteria"
            @keyup.enter.native="query"
            placeholder="请输入[姓名|手机号]"
            style="width:300px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="query">查询</el-button>
        </el-form-item>
        <el-form-item style="text-align:right">
          <el-button type="primary" @click="add()">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <el-table :data="datalist" highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column prop="cnee" label="收货人" width="150" sortable></el-table-column>
      <el-table-column prop="phone" label="手机" width="150" sortable></el-table-column>
      <el-table-column prop="area" label="所在地区" width="150" sortable></el-table-column>
      <el-table-column prop="addr" label="详细地址" width="200" sortable></el-table-column>
      <el-table-column label="操作" min-width="150">
        <template scope="scope">
          <el-button size="small" type="primary" @click="editAddr(scope.$index,scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="deleteAddr(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pull-right clearfix"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="totalsize"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <!-- 添加、修改地址输入框 -->
    <el-dialog :title="formtitle" :visible.sync="dialogFormVisible">
      <el-form
        ref="subData"
        :rules="rules"
        :model="subData"
        label-width="100px"
        @submit.prevent="onSubmit"
        style="margin:20px;"
      >
        <el-form-item label="收货人" prop="cnee">
          <el-input v-model="subData.cnee" placeholder="请输入收货人"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="phone">
          <el-input v-model="subData.phone" placeholder="请输入手机"></el-input>
        </el-form-item>
        <el-form-item label="所在地区" prop="area">
          <!-- 省市级联，数组形式
							<el-cascader
							style="width:196px"
								:options="options"
								v-model="selectedOptions"
								@change="handleChange">
						</el-cascader> 
          -->
          <el-input v-model="subData.area" placeholder="请输入所在地区"></el-input>
        </el-form-item>
        <el-form-item label="详细地址" prop="addr">
          <el-input type="textarea" v-model="subData.addr" placeholder="请输入详细地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAddr('subData')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RequestPost } from "../../api/api";
import { PageSize } from "../../api/api";
import { RequestGet } from "../../api/api";
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode
} from "element-china-area-data";
export default {
  data() {
    return {
      formtitle: "地址信息",
      listLoading: false,
      dialogFormVisible: false,
      subData: {},
      total: 0,
      currentPage: 1,
      totalsize: 0,
      page: {
        //地址信息列表
        pageSize: PageSize, //一页显示的条数
        criteria: "",
        customerId: sessionStorage.getItem("userId") //客户ID
      },
      datalist: [],
      options: regionData, //省市级联
      selectedOptions: [],
      rules: {
        cnee: [
          {
            required: true, //是否必填
            message: "收货人不能为空", //规则提示
            trigger: "blur" //何事件触发
          }
        ],
        phone: [
          {
            required: true, //是否必填
            message: "手机号不能为空", //规则提示
            trigger: "blur" //何事件触发
          },
          {
            pattern: /^1[34578]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ],
        addr: [
          {
            required: true, //是否必填
            message: "详细地址不能为空", //规则提示
            trigger: "blur" //何事件触发
          }
        ],
        area: [
          {
            required: true, //是否必填
            message: "所在地区不能为空", //规则提示
            trigger: "blur" //何事件触发
          }
        ]
      }
    };
  },

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNumber = val;
      this.page.pageNumber = val;
      /**
       * 1.get 请求传参数，必须是json前面加一个params
       * 2.post传参数不需要在json对象传值前面带params
       */
      this.loadData();
    },
    //加载数据
    loadData() {
      RequestGet("/customerAddr/getCustomerAddrList", this.page)
        .then(response => {
          if (response.code == "0000") {
            this.datalist = response.data;
            this.total = response.page.totalCount;
            this.totalsize = response.page.pageSize;
          }
        })
        .catch(error => {
          this.$router.push({ path: "/login" });
        });
    },

    /**
     * 查询
     */
    query() {
      this.loadData();
    },

    /**
     * 添加收货地址
     */
    add() {
      this.dialogFormVisible = true;
      this.formtitle = "新增收货地址";
      this.subData = {};
      this.isEdit = true;
      this.subData = {
        cnee: "",
        phone: "",
        area: "",
        customerId: sessionStorage.getItem("userId"),
        remark: "",
        type: "",
        state: "10"
      };
    },

    /**
     * 修改收货地址
     */
    editAddr(index, rows) {
      this.dialogFormVisible = true;
      this.formtitle = "修改收货地址";
      this.subData = rows;
    },

    /**
     * 删除收货地址
     */
    deleteAddr(index, rows) {
      this.$confirm("确认删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          RequestPost("/customerAddr/deleteAddr", rows)
            .then(response => {
              if (response.code == "0000") {
                this.$message({
                  message: response.message,
                  type: "success"
                });
                this.dialogFormVisible = false;
              } else {
                this.$message({
                  message: response.message,
                  type: "error"
                });
              }
              this.loadData();
            })
            .catch(error => {
              this.$router.push({ path: "/login" });
            });
          this.dialogFormVisible = false;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    /**
     * 保存收货地址
     */
    saveAddr(subData) {
      this.$refs[subData].validate(valid => {
        if (valid) {
          if (this.formtitle == "新增收货地址") {
            RequestPost("/customerAddr/addAddr", this.subData)
              .then(response => {
                if (response.code == "0000") {
                  this.$message({
                    message: response.message,
                    type: "success"
                  });
                  this.dialogFormVisible = false;
                } else {
                  this.$message({
                    message: response.message,
                    type: "error"
                  });
                }
                this.loadData();
              })
              .catch(error => {
                this.$router.push({ path: "/login" });
              });
          } else {
            RequestPost("/customerAddr/updateCustomerAddr", this.subData)
              .then(response => {
                if (response.code == "0000") {
                  this.$message({
                    message: response.message,
                    type: "success"
                  });
                  this.dialogFormVisible = false;
                } else {
                  this.$message({
                    message: response.message,
                    type: "error"
                  });
                }
                this.loadData();
              })
              .catch(error => {
                this.$router.push({ path: "/login" });
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //验证输入数据有效性
    check(subData) {
      if (subData.cnee == "") {
        this.$message({
          message: "请输入收货人",
          type: "error"
        });
        return false;
      }
      if (subData.phone == "") {
        this.$message({
          message: "请输入手机",
          type: "error"
        });
        return false;
      }
      var reg = /^1[3456789]\d{9}$/;
      if (!reg.test(subData.phone)) {
        this.$message({
          message: "手机输入不合法",
          type: "error"
        });
        return false;
      }
      if (subData.area == "") {
        this.$message({
          message: "请输入所在地区",
          type: "error"
        });
        return false;
      }
      if (subData.addr == "") {
        this.$message({
          message: "请输入详细地址",
          type: "error"
        });
        return false;
      }
      return true;
    },

    //省市级联触发后处理详细地址
    handleChange() {}
  },

  //初始化数据
  created: function() {
    this.loadData();
  }
};
</script>
<style>
.el-dialog--small {
  width: 30%;
}
.span {
  position: relative;
  padding: 8px;
}
.tip {
  display: block;
  background: #f00;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  top: 12px;
  right: 0px;
  position: absolute;
}
.customWidth {
  width: 50%;
}
</style>


// WEBPACK FOOTER //
// customerAddrList.vue?77c81f64